<template>
  <div class="section-h">
    <div class="section flex-column-center is-underlined" 
      v-for="(item, idx) in items" :key="idx"
      @click="activeItem = items[idx]">
      <img :src="item.media.image" alt="">
      <h2 class="is-size-3 has-text-centered">{{item.heading}}</h2>
    </div>
    <div class="flex-center push push-extra">
      <p class="loc is-uppercase has-text-centered is-size-4">Main concourse of the western metal supply co. building</p>
    </div>
    <div class="modal" :class="{'is-active': activeItem}">
      <div class="modal-background"></div>
      <div class="modal-content">
        <youtube v-if="activeItem && activeItem.media.youtube" 
        :video-id="getIdFromURL(activeItem.media.video)" 
        :player-vars="{rel:0,autoplay:0,showinfo:0,controls:1}"
        @ended="activeItem = null" @error="activeItem = null">
        </youtube>
        <video 
          v-if="activeItem && activeItem.media.video.length && !activeItem.media.youtube" 
          :src="activeItem.media.video"
          :poster="`${activeItem.media.poster}`"
          controls
          @ended="activeItem = null">
        </video>
        <div class="copy" v-if="activeItem" v-html="activeItem.copy"></div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="activeItem = null"></button>
    </div>
    <app-nav></app-nav>
  </div>
</template>

<script>
import { getIdFromURL } from 'vue-youtube-embed/lib/vue-youtube-embed.umd.js';

export default {
  name: 'about',
  data() {
    return {
      items: [
        {
          heading: "About the San Diego Sports Association",
          copy: "<p>The San Diego Sports Association exists to celebrate and support local athletic achievement and youth development through sports. Comprised of San Diego’s leading sports influencers, advocates, and supporters, the organization reaches more than 750,000 people per year through awards programs and community outreach initiatives.</p><p>The organization has a proud history and traces its roots back to the San Diego Hall of Champions and its legendary founder, the late Bob Breitbard. Bob established a number of awards and recognition programs, which continue to this day and are now featured within the Fowler Family Awards Center.</p>",
          media: {
            image: "/images/sdsa-logo-lg.png",
            video: "/videos/sdsa-video.mp4",
            youtube: false,
            poster: "/images/sdsa-poster.jpg"
          } 
        },
        {
          heading: "About the Fowler Family Awards Center",
          copy: "<p>The Fowler Family Awards Center is a searchable awards database that celebrates and chronicles the many honorees who were recognized by the San Diego Sports Association and Hall of Champions. This includes but is not limited to Stars of the Month, Stars of the Year, and the Breitbard Hall of Fame. The Fowler Family Awards Center was made possible by the generosity of Ron Fowler, longtime Chairman of the Board, and his wife Alexis. Ron was a close friend of the organization's late founder, Bob Breitbard, and like Bob, Ron is deeply committed to bettering the community through sports and celebrating local athletic achievement.</p>",
          media: {
            image: "/images/fowler.png",
            video: "",
            youtube: false,
            poster: ""
          }           
        },
        {
          heading: "About the Founder, Bob Breitbard",
          copy: 
            `
            <p>Bob Breitbard, the founder of the San Diego Hall of Champions, was a true visionary and man of the people. A native San Diegan, Bob was one of the most influential sports figures in the history of America’s Finest City, and his legacy of giving back to the community, recognizing and awarding sports excellence and bringing people together lives on to this day.</p>
            <p>Born April 28, 1919, Bob was as native a San Diegan as they come. He grew up in the city, attended (and played sports) at Hoover High School, went to San Diego State College—now known as San Diego State University—and went on to join the ranks as one of the school’s coaches in 1945, helping re-establish the football program following World War II.</p>
            <p>In 1946, the seed for the Hall of Champions was planted, when Bob started the Breitbard Athletic Foundation to promote educational work, encourage competition and recognize significant athletic achievement in San Diego. To this day, the vision for his Foundation lives on in the Hall’s monthly and annual awards programs.</p>
            <p>In 1961, Bob opened the Hall of Champions Sports Museum in Balboa Park. Although he was at the head of numerous sports ventures and programs in San Diego—including building the Sports Arena, helping launch the Greater San Diego Sports Association and helping bring the Rockets, Gulls, Chargers and Padres to town—building the Hall of Champions was perhaps his proudest achievement. It was the ultimate way to give back to his city and its citizens.</p>
            <p>In Bob Breitbard, San Diego Sports Keeper, Dan Fulop writes, “Beyond the surface of his legacy, Breitbard should be remembered and credited as an integral figure in the city’s journey from small town to big league.”</p>
            <p>Bob passed away in May 2010 at the age of 91. He will forever be remembered for his giving ways, love of sports and his desire to serve our community.</p>
            `,
          media: {
            image: "/images/breitbard.jpg",
            video: "https://www.youtube.com/embed/A3UeaqbpjxA",
            youtube: true,
            poster: ``
          }
        }
      ],
      activeItem: null,
      emailAddress: ''      
    }
  },
  methods: {
    getIdFromURL
  }
}
</script>

<style>
iframe, video {
  max-width: 100% !important;
}
</style>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/helpers.scss';

.modal-content {
  padding: 25px;
}

h2 {
  color: $gold;
}
.section {
  padding: 2rem 0;
  > img {
    max-height: 300px;
  }
}
.loc {
  font-family: 'DIN Next LT Pro M';
}
.copy {
  color: $blue;
}
</style>


